import { createApp, h, reactive } from 'vue'
import _ from 'lodash'
import axios from 'axios'
import Lang from 'lang.js'
import './fa-icons.js'

// Vue plugins
import {createInertiaApp, Link as InertiaLink} from '@inertiajs/vue3'
import BootstrapVue from 'bootstrap-vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import VueCookies from 'vue-cookies'

import AppLayout from './shared/AppLayout.vue'
import VMultiselect from './shared/VMultiselect.vue'

// Add config for date-fns
import { setDefaultOptions } from "date-fns"
import { nl } from "date-fns/locale"
setDefaultOptions({ locale: nl, weekStartsOn: 1 })

// Axios globally available
window.axios = axios

// Lodash globally available
window._ = _
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

// Add config to Vue
const appConfig = _.omit(window.app_config, ['default_locale', 'fallback_locale', 'messages'])
appConfig.showMobileContent = false

// Add translations to Vue
const locale = window.app_config.default_locale
const fallback = window.app_config.fallback_locale
const messages = window.app_config.messages
const lang = new Lang({messages, locale, fallback})

document.getElementsByTagName('title')[0].remove()

const pages = import.meta.glob('./pages/**/*.vue')

createInertiaApp({
    title: title => title ? `${title} - ${appConfig.app_name}` : appConfig.app_name,
    resolve: (name) => {
        const page = pages[`./pages/${name}.vue`]
        if (!page) {
            throw new Error(`Page not found: ${name}`)
        }
        return page().then(module => {
            module.default.layout = module.default.layout || AppLayout
            return module.default
        })
    },
    setup({ el, App, props, plugin }) {

        const app = createApp({
            render: () => h(App, props),
        })

        app.config.globalProperties.$appConfig = reactive(appConfig)

        app.use(plugin)
            .use(VueCookies, { expires: '7d' }) // set config for cookies
            .use(BootstrapVue, {
                BModal: {
                    okTitle: lang.get('generic.ok'),
                    cancelTitle: lang.get('generic.cancel'),
                    cancelVariant: 'link',
                },
                BFormFile: {
                    placeholder: lang.get('generic.input-file-placeholder'),
                    dropPlaceholder: lang.get('generic.input-file-drop-placeholder'),
                    browseText: lang.get('generic.input-file-browse-text')
                }
            })

        app.component('FontAwesomeIcon', FontAwesomeIcon)
            .component('inertia-link', InertiaLink)
            .component('v-multiselect', VMultiselect)

        app.directive('loadedifcomplete', {
            mounted: (el, binding) => {
                if (el.complete && binding.value) {
                    binding.value.loaded = true
                }
            }
        })

        app.mixin({
            computed: {
                csrf: () => document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            },
            methods: {
                log: (...messages) => console.log(...messages),
                trans: (key, replacements, locale) => lang.get(key, replacements, locale),
                choice: (key, number, replacements, locale) => lang.choice(key, number, replacements, locale),
                route: window.route,
            },
        })

        app.mount(el)
    }
})
